export default __webpack_public_path__ + "static/media/tool_item_4.953a2d34.png";